import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import config from '../config/config';
import './SupportTickets.css';

const SupportTickets = () => {
  const [tickets, setTickets] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');
  const history = useHistory();

  const statusOptions = [
    { value: '', label: 'All' },
    { value: '1', label: 'New' },
    { value: '2', label: 'In Progress' },
    { value: '3', label: 'On Hold' },
    { value: '4', label: 'Closed' }
  ];

  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const token = localStorage.getItem('superAdminToken');
        if (!token) {
          history.push('/login');
          return;
        }

        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        const response = await axios.get(`${config.serverUrl}/support/tickets`);
        setTickets(response.data);
      } catch (error) {
        setError('Failed to fetch support tickets. Please try again later.');
        console.error('Failed to fetch support tickets:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTickets();
  }, [history]);

  const handleTicketClick = (ticketId) => {
    history.push(`/support/ticket/${ticketId}`);
  };

  const handleFilterChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const filteredTickets = statusFilter
    ? tickets.filter(ticket => ticket.status.toString() === statusFilter)
    : tickets;

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="support-tickets-container">
      <h1>Support Tickets</h1>
      <div className="filter-container">
        <label>
          Filter by status: 
          <select value={statusFilter} onChange={handleFilterChange}>
            {statusOptions.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </label>
      </div>
      <table className="support-ticket-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Account</th>
            <th>Subject</th>
            <th>Status</th>
            <th>Date Created</th>
          </tr>
        </thead>
        <tbody>
          {filteredTickets.map(ticket => (
            <tr key={ticket.id} onClick={() => handleTicketClick(ticket.id)}>
              <td>{ticket.id}</td>
              <td>{ticket.accountName}</td>
              <td>{ticket.subject}</td>
              <td>{statusOptions.find(option => option.value === ticket.status.toString())?.label}</td>              
              <td>{new Date(ticket.createdAt).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SupportTickets;
